import __request__ from "routing/request";
export function getAllNotifications(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.customization/notifications", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createNotification(details, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.customization/notifications", details, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getSingleNotification(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.customization/notifications/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateNotification(id, details, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.customization/notifications/${id}`, details, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteNotification(notificationId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.customization/notifications/${notificationId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
